import React, { useMemo } from 'react';
import './ChecklistSection.scss';
import { useTranslation } from 'react-i18next';
import { ChecklistSection as ChecklistSectionType } from '../data/checklistData';
import ChecklistTask from './ChecklistTask';

const stripWrappingParentheses = (value: string): string =>
  value.replace(/^\s*\((.*)\)\s*$/, '$1');

interface ChecklistSectionProps {
  section: ChecklistSectionType;
  checkedTasks: Record<string, string>;
  onToggle: (taskId: string) => void;
}

const ChecklistSection: React.FC<ChecklistSectionProps> = ({
  section,
  checkedTasks,
  onToggle,
}) => {
  const { t } = useTranslation();

  const sectionProgress = useMemo(() => {
    const total = section.tasks.length;
    const checked = section.tasks.filter((task) => task.id in checkedTasks).length;
    return { checked, total };
  }, [section.tasks, checkedTasks]);

  const allChecked = sectionProgress.checked === sectionProgress.total;

  return (
    <div id={`section-${section.id}`} className="checklist-section">
      <div className="page-box__title-action">
        <div>
          <div className="page-box__title page-box__title--flex">
            {t(section.titleKey)}
          </div>
          {section.subtitleKey && (
            <div className="checklist-section__subtitle">
              {stripWrappingParentheses(t(section.subtitleKey))}
            </div>
          )}
        </div>
        <span className={`checklist-badge${allChecked ? ' checklist-badge--completed' : ''}`}>
          {sectionProgress.checked}/{sectionProgress.total}
        </span>
      </div>

      <div className="checklist-card checklist-section__tasks">
        {section.tasks.map((task) => (
          <ChecklistTask
            key={task.id}
            task={task}
            isChecked={task.id in checkedTasks}
            checkedDate={checkedTasks[task.id] ?? null}
            onToggle={() => onToggle(task.id)}
          />
        ))}
      </div>
    </div>
  );
};

export { ChecklistSection };
export default ChecklistSection;
